module.exports = __webpack_public_path__ + "media/images/lp_cv-block-2-sp-cb7e3ecf3d4a4a036dc3cee15163d2f4.webp";